module.exports = __webpack_public_path__ + "font/479970ffb74f2117317f9d24d9e317fe.woff2";